import React from 'react'
import {GridComponent,Toolbar,ColumnDirective,ColumnsDirective,Page,Search,Inject} from '@syncfusion/ej2-react-grids'
import {employeesData,employeesGrid} from '../data/dummy';

import {Header} from '../components';

const Employes = () => {
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <Header category="Page" title="Employes"/>
      <GridComponent 
        dataSource={employeesData}
        allowPaging
        allowSorting
        toolbar={['Search']}
        width="auto"
      >
        <ColumnsDirective>
          {employeesGrid.map((item,index) => (
            <ColumnDirective 
              key={index}
              {...item}
            />
          ))}
        </ColumnsDirective>
        <Inject services={[Page,Search,Toolbar]}/>
      </GridComponent>
    </div>
  )
}

export default Employes